export default __webpack_public_path__ + "7b0fec4e143f58c664d13b7b49386447.png";